import { DEFAULT_COVER_IMG } from '@/common/components/HeadMetaTags/HeadMetaTags';
import { PageConfig, RouteBuilder, RouteOptions } from '@/common/routes/RouteBuilder';
import { parseIdFromWebRequest } from '@/common/utils/sharedUtils';

export interface BrowseCollectionsPageParams {
  pageNo?: string;
}
interface BrowseCollectionsPageOptions extends RouteOptions, BrowseCollectionsPageParams {}

export const parseBrowseCollectionsPageNumber = (pageNo?: string): number => {
  const parsed = parseIdFromWebRequest(pageNo ?? '');
  return parsed === null ? 1 : parsed;
};

/**
 * @returns when page is 1 or 0: '/browse-collections' otherwise '/browse-collections/2'
 */
export const RouteToBrowseCollectionsPage = (options?: BrowseCollectionsPageOptions) => {
  const pageNo = parseBrowseCollectionsPageNumber(options?.pageNo);
  if (pageNo > 1) {
    return RouteBuilder({ ...options, path: `/browse-collections/${pageNo}`, target: 'elysium' });
  } else {
    return RouteBuilder({ ...options, path: `/browse-collections`, target: 'elysium' });
  }
};

export const BrowseCollectionsPageConfig: PageConfig = {
  readableName: 'Browse collections page',
  analyticsGaName: 'browse-collections',
  analyticsAthenaName: 'browse-collections',
  pagePathnames: ['/browse-collections', '/browse-collections/[pageNo]'],
  displayPromoBar: true,
  defaultMeta: {
    title: `Browse Collections & Poster Sets | Displate`,
    description: `Browse all metal poster collections &amp; sets created by talented designers. Hundreds of unique collections to choose your Displate from!`,
    coverImage: DEFAULT_COVER_IMG,
  },
};
